import { useTheme, type Theme } from '../lib/theme';

const OPTIONS: { value: Theme; label: string }[] = [
  { value: 'system', label: 'Auto' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

/**
 * A segmented control rather than a switch, because the third state is the important one:
 * `Auto` is how you give the decision back to the OS, and a two-way switch cannot express it.
 */
export default function ThemeToggle() {
  const [theme, set] = useTheme();

  return (
    <div className="themetoggle" role="radiogroup" aria-label="Colour theme">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={theme === o.value}
          onClick={() => set(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
